import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AdminUser } from '@reflact/ipkv-types/';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class User {
  private http = inject(HttpClient);

  public async getUsers() {
    return await firstValueFrom(this.http.get<AdminUser[]>("/api/admin/user/list"));
  }

  public async createUser(email: string, name: string) {
    return await firstValueFrom(this.http.post<AdminUser>("/api/admin/user/create", { email, name }));
  }

  public async updateUser(_id: string, email: string, name: string, active: boolean) {
    return await firstValueFrom(this.http.post<AdminUser>("/api/admin/user/update", { _id, email, name, active }));
  }

  public async deleteUser(_id: string) {
    return await firstValueFrom(this.http.post<AdminUser>("/api/admin/user/delete", { _id }))
  }

}
